const tournamentUx = {
  en: {
    myResult: 'My result',
    noOwnResult: 'No result for you in this tournament.',
    otherResults: 'Show other results ({count})',
    allResults: 'Show all results ({count})',
    collapseResults: 'Collapse results',
    chooseCharacter: 'Choose your character',
    applicantCount: '{count} applicants',
    drawHint: 'After signup closes, 32 participants will be selected for the tournament. Even if you are selected, you may be randomly assigned a different character if someone else chose the same one.',
    duration: '7 days',
    applicationPending: 'Applied · awaiting selection',
    applicationSubmitted: 'Applied, {name}',
    applicationSaved: 'Application saved: {name}. Participation is not yet confirmed.',
    changeCharacter: 'Update character',
    selectionResult: 'Selection result',
    selected: 'You have been selected for this tournament.',
    notSelected: 'You were not selected this time. Please apply again next time.',
    reassigned: 'Several applicants chose the same character, so this character was assigned to you automatically.',
    requestedCharacter: 'Your requested character: {name}',
    overview: 'Your tournament',
    entryStatus: 'Your status',
    readyToJoin: 'Ready to join',
    joined: 'Entry confirmed',
    competing: 'In the competition',
    eliminated: 'Your tournament run is complete',
    spectator: 'Following the tournament',
    waitingSignup: 'Waiting for signup',
    full: 'All player places are filled',
    completed: 'Tournament complete',
    cancelled: 'Tournament cancelled',
    todayOpponent: "Today's opponent",
    opponentPending: 'Opponent to be announced',
    noMatchToday: 'No match scheduled for you today',
    matchFinished: 'Finished',
    matchResolvedHint: "Today's match is finished. Your result is shown below.",
    matchResult: 'Result: {you} – {opponent} · {result}',
    win: 'Win',
    loss: 'Loss',
    joinHint: 'Choose a tournament nickname and fighter to enter.',
    joinedHint: 'Your place is saved. Keep training before the opening match.',
    practiceHint: "Today's practice points count toward this match. The result is calculated at the daily cutoff.",
    waitingHint: 'Your next match will appear when the draw is ready.',
    nextMatchHint: 'Your next match is scheduled. Keep training until match day.',
    spectatorHint: 'Signup has closed. You can follow the matches and results here.',
    eliminatedHint: 'Your results remain below. You can keep training for the next tournament.',
    completedHint: 'The final standings are ready below.',
    fullHint: 'You can still follow this tournament. No new entries are available.',
    signupAction: 'Choose your fighter',
    trainAction: 'Start training',
    nextSchedule: 'Next schedule',
    signupCloses: 'Signup closes',
    tournamentStarts: 'Opening match day',
    signupOpens: 'Signup opens',
    scoreCutoff: "Today's points cutoff",
    nextMatch: 'Your next match',
    tournamentEnds: 'Tournament ends',
    schedulePending: 'Schedule to be announced',
    matchDate: 'Day {day} · {date}',
    timezone: 'Times shown in Asia/Seoul (KST).',
    facts: '{players} players · {fighters} fighters · 7 days',
    yourMatch: 'Your match',
    you: 'You',
    pathHint: 'Your fighters and confirmed advancement path are highlighted.',
    bracketView: 'Bracket',
    listView: 'Match list',
    viewLabel: 'Tournament view',
    roundPending: 'The matchups for this round are not decided yet.',
    awaitingScore: 'Awaiting result',
    noTournament: 'The next tournament is not available yet.',
    retryHint: 'Refresh to check the tournament schedule.',
    result: {
      champion: 'Champion', runnerUp: 'Runner-up', semiFinalist: 'Semifinalist',
      quarterFinalist: 'Quarterfinalist', roundOf16: 'Round of 16', groupStage: 'Group stage',
    },
  },
  ko: {
    myResult: '내 결과',
    noOwnResult: '이 대회에는 내 결과가 없어요.',
    otherResults: '다른 참가자 결과 보기 ({count}명)',
    allResults: '전체 결과 보기 ({count}명)',
    collapseResults: '결과 접기',
    chooseCharacter: '참가 캐릭터 선택',
    applicantCount: '지원자 {count}명',
    drawHint: '접수 마감후 대회에 참가할 32인을 선정합니다. 통과했더라도 누군가 중복된 캐릭터를 선택했다면 랜덤으로 다른 캐릭터가 선택 될 수 있습니다.',
    duration: '7일간',
    applicationPending: '지원 완료 · 선정 대기',
    applicationSubmitted: '지원완료, {name}',
    applicationSaved: '지원한 캐릭터: {name}. 아직 참가가 확정되지 않았습니다.',
    changeCharacter: '캐릭터 변경하기',
    selectionResult: '참가자 선정 결과',
    selected: '이번 대회 참가자로 선정되었습니다.',
    notSelected: '이번엔 선정되지 않았습니다. 다음에 지원 부탁드립니다.',
    reassigned: '같은 캐릭터 지원자가 많아, 이 캐릭터로 자동 배정되었습니다.',
    requestedCharacter: '지원한 캐릭터: {name}',
    overview: '나의 대회 현황',
    entryStatus: '내 참가 상태',
    readyToJoin: '참가 신청 가능',
    joined: '참가 확정',
    competing: '대회 참가 중',
    eliminated: '이번 대회 경기를 마쳤어요',
    spectator: '대회 관전 중',
    waitingSignup: '참가 접수 대기',
    full: '참가 정원이 모두 찼어요',
    completed: '대회 종료',
    cancelled: '대회 취소',
    todayOpponent: '오늘의 상대',
    opponentPending: '상대 발표 대기',
    noMatchToday: '오늘 예정된 내 경기가 없어요',
    matchFinished: '경기 종료',
    matchResolvedHint: '오늘 경기가 끝났어요. 아래에서 경기 결과를 확인하세요.',
    matchResult: '경기 결과: {you} – {opponent} · {result}',
    win: '승리',
    loss: '패배',
    joinHint: '대회 닉네임과 선수를 선택해 참가하세요.',
    joinedHint: '참가가 확정됐어요. 개막 전까지 꾸준히 훈련해 보세요.',
    practiceHint: '오늘 얻은 학습 포인트가 이 경기에 반영돼요. 하루 집계가 끝나면 결과가 결정됩니다.',
    waitingHint: '대진이 결정되면 다음 경기가 표시돼요.',
    nextMatchHint: '다음 경기가 예정돼 있어요. 경기일까지 꾸준히 훈련해 보세요.',
    spectatorHint: '참가 접수가 마감됐어요. 여기에서 경기와 결과를 확인할 수 있어요.',
    eliminatedHint: '아래에서 내 경기 결과를 확인하고, 다음 대회를 위해 계속 훈련할 수 있어요.',
    completedHint: '아래에서 최종 순위를 확인하세요.',
    fullHint: '지금은 새로 참가할 수 없지만 대회 경기는 계속 확인할 수 있어요.',
    signupAction: '참가 선수 선택하기',
    trainAction: '훈련하기',
    nextSchedule: '다음 일정',
    signupCloses: '참가 접수 마감',
    tournamentStarts: '대회 개막',
    signupOpens: '참가 접수 시작',
    scoreCutoff: '오늘 포인트 집계 마감',
    nextMatch: '내 다음 경기',
    tournamentEnds: '대회 종료',
    schedulePending: '일정 발표 대기',
    matchDate: '{day}일차 · {date}',
    timezone: '일정은 한국 시간(KST) 기준이에요.',
    facts: '플레이어 {players}명 · 선수 {fighters}명 · 7일간',
    yourMatch: '내 경기',
    you: '나',
    pathHint: '내 선수와 확정된 진출 경로를 강조했어요.',
    bracketView: '대진표',
    listView: '경기 목록',
    viewLabel: '대회 보기 방식',
    roundPending: '아직 이 라운드의 대진이 결정되지 않았어요.',
    awaitingScore: '결과 집계 대기',
    noTournament: '아직 다음 대회 정보가 없어요.',
    retryHint: '새로고침해서 대회 일정을 확인해 보세요.',
    result: {
      champion: '우승', runnerUp: '준우승', semiFinalist: '4강',
      quarterFinalist: '8강', roundOf16: '16강', groupStage: '조별 리그',
    },
  },
};

export default tournamentUx;
